import { useState } from 'react';
import type { Rect as RectType } from 'react-use-rect';
import { useRect as useRectHook, useWindowOn } from 'react-use-rect';

export type UseRectOptions = {
  withRevalidateOnScroll?: boolean;
  withRevalidateOnResize?: boolean;
};

export type Rect = RectType;

export const INITIAL_AREA_RECT: Rect = {
  top: 0,
  bottom: 0,
  width: 0,
  height: 0,
  left: 0,
  right: 0,
  x: 0,
  y: 0
};

export const useRect = ({
  withRevalidateOnScroll,
  withRevalidateOnResize
}: UseRectOptions = {}) => {
  const [bounds, setBounds] = useState<Rect>(INITIAL_AREA_RECT);
  const [ref, revalidate] = useRectHook((rect) => {
    setBounds(rect);
  });

  withRevalidateOnScroll &&
    useWindowOn('scroll', () => revalidate({ force: true }));
  withRevalidateOnResize &&
    useWindowOn('resize', () => revalidate({ force: true }));

  return { ref, bounds };
};

export function hasMeasureBounds(rect: Rect) {
  return Object.values(rect).some((value) => value !== 0);
}
